$(document).ready(function(){
  $(".navbar-toggler").click(function(e) {
    $(".navbar-icon").toggleClass("d-none");
  });
});
